export const canManageGreenerUnitInstances = (userRole) => {
  return !!userRole?.canManageGreenerUnitInstances;
};

export const canCreateProjects = (userRole) => {
  return !!userRole?.['project:create'];
};

export const canEditProjects = (userRole) => {
  return !!userRole?.['project:update'];
};

export const canDeleteProjects = (userRole) => {
  return !!userRole?.['project:delete'];
};

export const canPlanUnits = (userRole) => {
  return !!userRole.canAssignGreenerUnitInstances;
};

export const canManageMicrogrids = (userRole) => {
  return !!userRole.canManageMicrogrids;
};

export const canSeeAnalyticalData = (userRole) => {
  return !!userRole.canSeeAnalyticalData;
};

export const canRequestProjectReports = (userRole) => {
  return !!userRole.canRequestProjectReports;
};

export const canSeeAlerts = (userRole = {}) => {
  return !!userRole?.['alert:read'];
};

export const canDeleteProjectReports = (userRole) => {
  return !!userRole?.['report:delete'];
};

export const canCreateUser = (userRole) => {
  return !!userRole?.['user:create'];
};

export const canUpdateUser = (userRole) => {
  return !!userRole?.['user:update'];
};

export const canDeleteUser = (userRole) => {
  return !!userRole?.['user:delete'];
};

export const canCreateOrganisation = (userRole) => {
  return !!userRole?.['organisation:create'];
};

export const canCreateAsset = (userRole) => {
  return !!userRole?.['greenerUnit:create'];
};

export const canReadAsset = (userRole) => {
  return !!userRole?.['greenerUnit:read'];
};

export const canUpdateAsset = (userRole) => {
  return !!userRole?.['greenerUnit:update'];
};

export const canSeeOperatorChat = (userRole) => {
  return !!userRole?.['greenerUnit:chat'];
};

export const canCreateEye = (userRole) => {
  return !!userRole?.['greenerEye:create'];
};

export const canCreateWatcherType = (userRole) => {
  return !!userRole?.['watcherType:create'];
};

export const canCreateDeviceModel = (userRole) => {
  return !!userRole?.['deviceModel:create'];
};

export const canCreateUserRoles = (userRole) => {
  return !!userRole?.['user:create']; // TODO refactor when permission user_role:create will be added
};

export const canSeeAlertEmailRecipients = (userRole) => {
  return !!userRole['organisationAlertEmailRecipient:read'];
};

export const canCreateAlertEmailRecipients = (userRole) => {
  return !!userRole['organisationAlertEmailRecipient:create'];
};

export const canDeleteAlertEmailRecipients = (userRole) => {
  return !!userRole['organisationAlertEmailRecipient:delete'];
};

export const canDeleteOrganisations = (userRole) => {
  return !!userRole['organisation:delete'];
};

export const canSeeBlueprints = (userRole) => {
  return !!userRole['blueprint:read'];
};

export const canCreateBlueprints = (userRole) => {
  return !!userRole['blueprint:create'];
};

export const canUpdateBlueprints = (userRole) => {
  return !!userRole['blueprint:update'];
};

// Equipment permissions - granular permissions
export const canCreateEquipment = (userRole) => {
  return !!userRole?.['equipment:create'];
};

export const canReadEquipment = (userRole) => {
  return !!userRole?.['equipment:read'];
};

export const canUpdateEquipment = (userRole) => {
  return !!userRole?.['equipment:update'];
};

export const canDeleteEquipment = (userRole) => {
  return !!userRole?.['equipment:delete'];
};

export const canSeeFleets = (userRole) => {
  return !!userRole?.['fleet:read'];
};

export const canCreateFleet = (userRole) => {
  return !!userRole?.['fleet:create'];
};

export const canUpdateFleet = (userRole) => {
  return !!userRole?.['fleet:update'];
};

export const canCreateAlertRobocallRecipients = (userRole) => {
  return !!userRole?.['organisationAlertRobocallRecipient:create'];
};

export const canDeleteAlertRobocallRecipients = (userRole) => {
  return !!userRole?.['organisationAlertRobocallRecipient:delete'];
};

export const canCreateProjectOrganisations = (userRole) => {
  return !!userRole?.['projectOrganisation:create'];
};

export const canDeleteProjectOrganisations = (userRole) => {
  return !!userRole?.['projectOrganisation:delete'];
};

//Flag of internal features in the absence of a user role

export const isGreenerEmployee = (user) => user?.organisation?.externalIdentifier === 'greener';
